import Fuse from "fuse.js"
import { sortByDate } from "../../../components/Table/sorting";

const searchServiceRequests = (serviceRequests, searchString) => {
  const fuse = new Fuse(serviceRequests, {
    minMatchCharLength: 2,
    threshold: 0.3,
    keys: ['number', 'description', 'area', 'item', 'type', 'status', 'ticketNumber']
  });
  return fuse.search(searchString).map(result => result.item);
}

const groupServiceRequests = (serviceRequests) => {
  const {serviceRequest, groups} = serviceRequests.reduce((acc, serviceRequest) => {
    if(serviceRequest.groupId) {
      const group = acc.groups.find(group => group.id === serviceRequest.groupId);
      if(group) {
        group.children.push({...serviceRequest, name: serviceRequest.number, isGroup: false});
      } else {
        acc.groups.push({
          ...serviceRequest,
          id: serviceRequest.groupId,
          name: serviceRequest.groupName,
          children: [{...serviceRequest, name: serviceRequest.number, isGroup: false}],
          isGroup: true
        });
      }
    } else {
      acc.serviceRequest.push({...serviceRequest, name: serviceRequest.number, isGroup: false});
    }
    return acc;
  }, {serviceRequest: [], groups: []});
  return [...serviceRequest, ...groups];
}

export const filterServiceRequests = (serviceRequests, {
  searchString,
  pagination,
}) => {
  if(Array.isArray(serviceRequests) === false) return [];
  let filteredServiceRequests = serviceRequests;
  filteredServiceRequests = searchString.length > 2 ? searchServiceRequests(filteredServiceRequests, searchString) : serviceRequests;
  filteredServiceRequests = groupServiceRequests(filteredServiceRequests);
   
  filteredServiceRequests.sort((a,b) => sortByDate(b.createdDate, a.createdDate));
  return filteredServiceRequests.slice(0, pagination);
}